/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import { CardSection } from '../CardSection';
import './CardBodyStyles.scss';
const baseClass = 'qmb-ui-card-body';
/**
 * CardBody Component
 * Renders stacked CardSection components inside the card.
 * @version 1.0.0
 * @since 2026-02-18
 */
export function CardBody({ sections, variant, className }) {
    return (React.createElement("dl", { className: classNames(baseClass, className) }, sections.map((section, index) => (React.createElement(CardSection, { key: index, label: section.label, variant: variant, copyText: section.copyText, isLast: index === sections.length - 1 }, section.content)))));
}
